module.exports = __webpack_public_path__ + "img/allergan-logo.a1683b6f.png";